// extracted by mini-css-extract-plugin
export default {"video":"PageBuilderVideo-module-video-1ak","videoWrapper":"PageBuilderVideo-module-videoWrapper-3pf"};